module.exports = __webpack_public_path__ + "static/media/itemvisual.c05e9f04.less";